import {
  EMPTY,
  ERROR,
  READY,
  LOADING,
} from '@blueberry/constants/loadingState';

export const types = {
  FETCH_PRACTICE_SUBJECTS: 'FETCH_PRACTICE_SUBJECTS',
  FETCH_PRACTICE_SUBJECTS_SUCCESS: 'FETCH_PRACTICE_SUBJECTS_SUCCESS',
  FETCH_PRACTICE_SUBJECTS_FAILURE: 'FETCH_PRACTICE_SUBJECTS_FAILURE',
  VIEW_CONCEPTS_PAGE: 'VIEW_CONCEPTS_PAGE',
  FETCH_RPACTICE_SUBJECT_CONCEPTS: 'FETCH_PRACTICE_SUBJECT_CONCEPTS',
  FETCH_PRACTICE_SUBJECT_CONCEPTS_SUCCESS:
    'FETCH_PRACTICE_SUBJECT_CONCEPTS_SUCCESS',
  FETCH_PRACTICE_SUBJECT_CONCEPTS_FAILURE:
    'FETCH_PRACTICE_SUBJECT_CONCEPTS_FAILURE',
  FETCH_PRACTICE_CONCEPT: 'FETCH_PRACTICE_CONCEPT',
  FETCH_PRACTICE_CONCEPT_SUCCESS: 'FETCH_PRACTICE_CONCEPT_SUCCESS',
  FETCH_PRACTICE_CONCEPT_FAILURE: 'FETCH_PRACTICE_CONCEPT_FAILURE',
  FETCH_PRACTICE_QUIZZES: 'FETCH_PRACTICE_QUIZZES',
  FETCH_PRACTICE_QUIZZES_SUCCESS: 'FETCH_PRACTICE_QUIZZES_SUCCESS',
  FETCH_PRACTICE_QUIZZES_FAILURE: 'FETCH_PRACTICE_QUIZZES_FAILURE',
  SELECT_ANSWER_OF_QUIZ: 'SELECT_ANSWER_OF_QUIZ',
  FINISH_PRACTICE_QUIZZES: 'FINISH_PRACTICE_QUIZZES',
  CHANGE_PRACTICE_TUTORIAL_STAGE: 'CHANGE_PRACTICE_TUTORIAL_STAGE',
  CLEAR_PARCTICE_QUIZZES: 'CLEAR_PARCTICE_QUIZZES',
};

export const viewConceptsPage = () => ({
  type: types.VIEW_CONCEPTS_PAGE,
});

export const fetchPracticeSubjects = () => ({
  type: types.FETCH_PRACTICE_SUBJECTS,
});

export const fetchPracticeSubjectsSuccess = (subjects, selectedSubjectId) => ({
  type: types.FETCH_PRACTICE_SUBJECTS_SUCCESS,
  payload: {
    subjects,
    selectedSubjectId,
  },
});

export const fetchPracticeSubjectsFailure = err => ({
  type: types.FETCH_PRACTICE_SUBJECTS_FAILURE,
  payload: {
    err,
  },
});

export const fetchSubjectConcepts = id => ({
  type: types.FETCH_RPACTICE_SUBJECT_CONCEPTS,
  payload: {
    id,
  },
});

export const fetchSubjectConceptsSuccess = ({ concepts, levels }) => ({
  type: types.FETCH_PRACTICE_SUBJECT_CONCEPTS_SUCCESS,
  payload: {
    concepts,
    levels,
  },
});

export const fetchSubjectConceptsFailure = err => ({
  type: types.FETCH_PRACTICE_SUBJECT_CONCEPTS_FAILURE,
  payload: {
    err,
  },
});

export const fetchPracticeConcept = id => ({
  type: types.FETCH_PRACTICE_CONCEPT,
  payload: {
    id,
  },
});

export const fetchPracticeConceptSuccess = concept => ({
  type: types.FETCH_PRACTICE_CONCEPT_SUCCESS,
  payload: {
    concept,
  },
});

export const fetchPracticeConceptFailure = err => ({
  type: types.FETCH_PRACTICE_CONCEPT_FAILURE,
  payload: {
    err,
  },
});

export const fetchPracticeQuizzes = conceptId => ({
  type: types.FETCH_PRACTICE_QUIZZES,
  payload: {
    conceptId,
  },
});

export const fetchPracticeQuizzesSuccess = quizzes => ({
  type: types.FETCH_PRACTICE_QUIZZES_SUCCESS,
  payload: {
    quizzes,
  },
});

export const fetchPracticeQuizzesFailure = err => ({
  type: types.FETCH_PRACTICE_QUIZZES_FAILURE,
  payload: {
    err,
  },
});

export const selectAnswerOfQuiz = (quizIndex, answerIndex) => ({
  type: types.SELECT_ANSWER_OF_QUIZ,
  payload: {
    quizIndex,
    answerIndex,
  },
});

export const changePracticeTutorialStage = stage => ({
  type: types.CHANGE_PRACTICE_TUTORIAL_STAGE,
  payload: {
    stage,
  },
});

export const finsihPracticeQuizzes = id => ({
  type: types.FINISH_PRACTICE_QUIZZES,
  payload: {
    id,
  },
});

export const clearPracticeQuizzes = () => ({
  type: types.CLEAR_PARCTICE_QUIZZES,
});

const initalState = {
  showPracticeConcepts: false,
  subjects: [],
  status: EMPTY,
  selectedSubjectId: undefined,
  concepts: [],
  levels: undefined,
  selectedConcept: undefined,
  quizzes: [],
  tutorialStage: 0,
  quizStatus: EMPTY,
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case types.VIEW_CONCEPTS_PAGE:
      return {
        ...state,
        showPracticeConcepts: true,
      };
    case types.FETCH_PRACTICE_SUBJECTS_FAILURE:
      return {
        ...state,
        status: ERROR,
      };
    case types.FETCH_PRACTICE_SUBJECTS_SUCCESS:
      return {
        ...state,
        status: READY,
        subjects: action.payload.subjects,
        selectedSubjectId: action.payload.selectedSubjectId,
      };
    case types.FETCH_RPACTICE_SUBJECT_CONCEPTS:
      return {
        ...state,
        selectedSubjectId: action.payload.id,
        status: LOADING,
      };
    case types.FETCH_PRACTICE_SUBJECT_CONCEPTS_SUCCESS:
      return {
        ...state,
        status: READY,
        concepts: action.payload.concepts,
        levels: action.payload.levels,
      };
    case types.FETCH_PRACTICE_SUBJECT_CONCEPTS_FAILURE:
      return {
        ...state,
        status: ERROR,
      };
    case types.FETCH_PRACTICE_CONCEPT:
      return {
        ...state,
        selectedConcept: undefined,
      };
    case types.FETCH_PRACTICE_CONCEPT_SUCCESS:
      return {
        ...state,
        status: READY,
        selectedConcept: action.payload.concept,
      };
    case types.FETCH_PRACTICE_CONCEPT_FAILURE:
      return {
        ...state,
        status: ERROR,
      };
    case types.FETCH_PRACTICE_QUIZZES:
      return {
        ...state,
        quizStatus: LOADING,
        quizzes: initalState.quizzes,
      };
    case types.FETCH_PRACTICE_QUIZZES_SUCCESS:
      return {
        ...state,
        quizStatus: READY,
        quizzes: action.payload.quizzes,
      };
    case types.FETCH_PRACTICE_QUIZZES_FAILURE:
      return {
        ...state,
        quizStatus: ERROR,
      };
    case types.SELECT_ANSWER_OF_QUIZ:
      return {
        ...state,
        quizzes: state.quizzes.map((q, qIndex) => {
          if (qIndex === action.payload.quizIndex) {
            q.selectedAnswer = action.payload.answerIndex;
          }

          return q;
        }),
      };
    case types.CHANGE_PRACTICE_TUTORIAL_STAGE:
      return {
        ...state,
        tutorialStage: action.payload.stage,
      };
    case types.CLEAR_PARCTICE_QUIZZES:
      return {
        ...state,
        quizzes: initalState.quizzes,
      };
    default:
      return state;
  }
};

export default reducer;

export const getShowPracticeConcepts = state =>
  state.practice.showPracticeConcepts;
export const getPracticeSubjects = state => state.practice.subjects;
export const getSelectedSubjectId = state => state.practice.selectedSubjectId;
export const getPracticeConcepts = state => state.practice.concepts;
export const getPracticeLevels = state => state.practice.levels;
export const getSelectedConcept = state => state.practice.selectedConcept;
export const getLoadingStatus = state => state.practice.status;
export const getQuizzes = state => state.practice.quizzes;
export const getPracticeTutorialStage = state => state.practice.tutorialStage;
export const getQuizLoadingStatus = state => state.practice.quizStatus;



// WEBPACK FOOTER //
// ./app/redux/practice.js